import { render, staticRenderFns } from "./ObjectAttributes.vue?vue&type=template&id=0dd6b65e&scoped=true&"
import script from "./ObjectAttributes.vue?vue&type=script&lang=js&"
export * from "./ObjectAttributes.vue?vue&type=script&lang=js&"
import style0 from "./ObjectAttributes.vue?vue&type=style&index=0&id=0dd6b65e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd6b65e",
  null
  
)

export default component.exports